import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility.js';

const initialState = {
    message: false,
    scope: false,
    key: false,
    type: false,
    obj: {}
};

/* ----------------- Registration ------------------ */
const visualMessageSet = ( state, action ) => {
    return updateObject( state, {
        message: action.payload.message,
        scope: action.payload.scope,
        key: action.payload.key,
        type: action.payload.type,
        obj: action.payload.obj ? action.payload.obj : {}
    } );
};

const visualMessageReset = ( state, action ) => {
    return updateObject( state, {
        message: false,
        scope: false,
        key: false,
        type: false,
        obj: {}
    } );
};
/* ----------------- Reducer ------------------ */
const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.VISUALMESSAGE_SET: return visualMessageSet( state, action );
        case actionTypes.VISUALMESSAGE_RESET: return visualMessageReset( state, action );
        default: return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/visualMessage.js